import React, { Component } from "react";
import * as s from "./CollectionTagSlider.module.scss";
import { Tag } from "src/views/shared/components";
import { Icons } from "src/libs/assets";
import { ISingleWordpressCollection, ICollectionSliderRow } from "src/models";
import { inject, observer } from "mobx-react";
import { UIStore } from "src/stores";
import { truncate } from "src/libs/utils";

const SCROLL_OFFSET = 10;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  rows: [ICollectionSliderRow] | any;
  currentRow: ICollectionSliderRow | any;
  currentRowIdx: any;
  onChange?:
    | ((ISingleWordpressCollection, key) => void)
    | ((ISingleWordpressCollection, key, id?) => void);
  uiStore?: UIStore;
  size?: "small" | "medium" | "big";
  isArticle?: boolean;
  sliderId?: number;
}

interface State {
  formattedCollections: ISingleWordpressCollection[];
  lastTouchX: Number;
  rightArrowOpacity: Number;
  leftArrowOpacity: Number;
  activeTag: Number;
  scrollPos: Number;
  showNavigation: boolean;
  checkDesktop: boolean;
}

@inject("uiStore")
@observer
export class CollectionTagSlider extends Component<Props, State> {
  private tagWrapperRef: React.RefObject<HTMLDivElement>;
  state = {
    formattedCollections: [],
    lastTouchX: 0,
    rightArrowOpacity: 0,
    leftArrowOpacity: 0,
    activeTag: 0,
    scrollPos: 0,
    showNavigation: true,
    checkDesktop: true
  };

  constructor(props: any) {
    super(props);
    this.tagWrapperRef = React.createRef();
    const { rows, currentRowIdx } = this.props;
    this.state = {
      formattedCollections: rows,
      lastTouchX: 0,
      rightArrowOpacity: 0,
      leftArrowOpacity: 0,
      activeTag: currentRowIdx,
      scrollPos: 0,
      showNavigation: true,
      checkDesktop: true
    };
  }
  onChangeTag = (rows, idx) => {
    this.setState({ activeTag: idx });
    const { formattedCollections } = this.state;
    const { onChange, isArticle, sliderId } = this.props;

    isArticle
      ? onChange(formattedCollections[idx], idx, sliderId)
      : onChange(formattedCollections[idx], idx);
    if (idx === rows.length - 1) {
      const maxScroll =
        this.tagWrapperRef?.current?.scrollWidth -
        this.tagWrapperRef?.current?.clientWidth;
      this.tagWrapperRef.current.scrollLeft = maxScroll;
    }
  };

  renderCollectionTag = (row: ICollectionSliderRow, key: number) => {
    const { size, rows, uiStore } = this.props;
    const { isDesktop } = uiStore;
    const { collection, topic, keyword } = row || {};
    const { link } = collection || topic || keyword || {};
    let heading = collection?.title || topic?.name || keyword?.name;
    let tagClasses = [s.tag];
    let isActive = this.state.activeTag === key; //key === Math.floor(rows?.length / 2);
    rows?.length > 5 && rows?.length % 2 == 0
      ? tagClasses.push(s.even)
      : tagClasses.push(s.odd);
    var tagStyle = { order: `${key}` };
    if (heading?.length > 60) {
      tagClasses.push(s.small);
    }
    if (size === "medium" && !isDesktop) {
      heading = truncate(heading, 18);
    } else {
      heading = truncate(heading, 25);
    }
    return (
      <Tag
        title={heading}
        active={isActive}
        style={tagStyle}
        url={link}
        bordered={!isActive}
        rounded
        size={size}
        key={key}
        collectionId={key}
        className={tagClasses.join(" ")}
        onChange={this.onChangeTag}
        rows={rows}
      />
    );
  };
  componentDidUpdate(prevProps: any) {
    const { rows, currentRowIdx } = this.props;

    if (this.tagWrapperRef.current && prevProps.rows.length !== rows.length) {
      this.setState({
        formattedCollections: rows,
        activeTag: currentRowIdx
      });
      this.tagWrapperRef.current.scrollLeft = 0;
      this.setState({
        showNavigation:
          this.tagWrapperRef?.current?.scrollWidth >
          this.tagWrapperRef?.current?.clientWidth
      });
    }
  }
  formatCollectionsArrayToRender = () => {
    const { currentRow, rows } = this.props;
    let before = rows && rows.slice(0, Math.floor(rows?.length / 2));
    let after = rows && rows.slice(Math.ceil(rows?.length / 2), rows.length);
    const maybeIndex = after.findIndex(
      row =>
        row?.collection?.id === currentRow?.collection?.id ||
        row?.topic?.id === currentRow?.topic?.id ||
        row?.keyword?.id === currentRow?.keyword?.id
    );
    if (maybeIndex !== -1 && rows?.length % 2 === 0) after.splice(maybeIndex, 1);
    let formattedCollections = before && before.concat([currentRow], after);
    return formattedCollections;
  };

  previousTag = () => {
    this.tagWrapperRef.current.scrollLeft -= 300;
  };

  nextTag = () => {
    this.tagWrapperRef.current.scrollLeft += 300;
  };

  componentDidMount() {
    this.setState({
      showNavigation:
        this.tagWrapperRef?.current?.scrollWidth >
        this.tagWrapperRef?.current?.clientWidth
    });
  }

  setScroll() {
    if (this.tagWrapperRef?.current) {
      const { current } = this.tagWrapperRef;

      const maxScroll = current?.scrollWidth - current?.clientWidth;

      if (
        current?.scrollLeft < 20 ||
        current?.scrollLeft + 20 > maxScroll - 10 ||
        current?.scrollLeft > maxScroll - 10
      )
        this.setState({ scrollPos: this.tagWrapperRef.current.scrollLeft });
    }
  }

  render() {
    const { formattedCollections } = this.state;
    const { rows, className, uiStore } = this.props;
    const { isDesktop } = uiStore;
    const { isArticle } = this.props;
    let tagSliderClasses = [s.tagSlider];
    let tagsWrapperClass = [s.tagsWrapper];
    let showNavigation = false;
    if (rows?.length >= 2 && this.state.showNavigation) {
      showNavigation = true;
    } else {
      if (rows?.length < 5) {
        tagsWrapperClass = [s.tagsWrapperSmall];
      }
    }

    let buttonClasses = [s.buttonWrapper];
    if (className) tagSliderClasses.push(className);

    const showLeftArrow = showNavigation && this.state.scrollPos > SCROLL_OFFSET;
    const showRightArrow =
      showNavigation &&
      this.tagWrapperRef?.current &&
      (this.state.scrollPos + SCROLL_OFFSET <
        this.tagWrapperRef?.current?.scrollWidth -
          this.tagWrapperRef?.current?.clientWidth ||
        this.state.scrollPos === 0);
    return (
      <div className={tagSliderClasses.join(" ")}>
        <div
          className={[
            buttonClasses,
            isArticle ? s.smallLeft : s.left,
            showLeftArrow ? s.show : ""
          ].join(" ")}
          onClick={this.previousTag}
        >
          <div
            className={[s.navigationButton, s.left, isArticle && s.smallOpacity].join(
              " "
            )}
            style={{ opacity: isDesktop ? 1 : this.state.leftArrowOpacity }}
          >
            <img src={Icons.previous_large} alt="Back arrow" />
          </div>
        </div>
        <div
          className={tagsWrapperClass.join(" ")}
          ref={this.tagWrapperRef}
          onScroll={this.state.showNavigation ? this.setScroll.bind(this) : undefined}
        >
          {formattedCollections?.map(this.renderCollectionTag)}
        </div>
        <div
          className={[
            buttonClasses,
            isArticle ? s.smallRight : s.right,
            showRightArrow ? s.show : ""
          ].join(" ")}
          onClick={this.nextTag}
        >
          <div
            className={[s.navigationButton, s.right, isArticle && s.smallOpacity].join(
              " "
            )}
            style={{ opacity: isDesktop ? 1 : this.state.rightArrowOpacity }}
          >
            <img src={Icons.next_large} alt="Forward arrow" />
          </div>
        </div>
      </div>
    );
  }
}
